export const ListServiceConferPage = (destinationLang) => {
  return [
    {
      FormKey: "list-service-confer-confirm",
      Key: "تسويه",
      DistinitationLanguage: destinationLang,
    },

    {
      FormKey: "general-public-alert-settlement-confirm",
      Key: "آيا از تسويه اطمينان داريد؟",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "general-public-alert-settlement-confirm-delete",
      Key: "آيا از حذف اطمينان داريد؟",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "list-service-confer-label-settled",
      Key: "تسویه شده",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "list-service-confer-label-notsettled",
      Key: "تسویه نشده",
      DistinitationLanguage: destinationLang,
    },
    {
      FormKey: "list-service-dialog-change-discount",
      Key: "ویرایش تخفیف بسته",
      DistinitationLanguage: destinationLang,
    },
  ];
};
